import { Injectable, NgZone, EventEmitter } from '@angular/core'

import { ReplaySubject } from 'rxjs/ReplaySubject'

export interface PlayerOutputs {
  ready?: EventEmitter<YT.Player>
  change?: EventEmitter<YT.Events>
}

export interface PlayerSize {
  width?: number
  height?: number
}

@Injectable()
export class YoutubePlayerService {

  static get win() {
    return window
  }

  static get YT() {
    return YoutubePlayerService.win['YT']
  }

  static get Player() {
    return YoutubePlayerService.YT.Player
  }

  private api: ReplaySubject<YT.Player>

  private defaultSize: PlayerSize = {
    width: 367,
    height: 270
  }

  private readonly iframeScriptId = 'youtube-iframe-api'

  constructor(private zone: NgZone) {
    this.createApi()
  }

  public loadPlayerApi() {
    if (window.document.getElementById(this.iframeScriptId) == null) {
      const playerApiScript = window.document.createElement('script')
      playerApiScript.type = 'text/javascript'
      playerApiScript.src = 'https://www.youtube.com/iframe_api'
      playerApiScript.id = this.iframeScriptId

      YoutubePlayerService.win.document.body.appendChild(playerApiScript)
    }
  }

  public setupPlayer(elementId: string, outputs: PlayerOutputs, size: PlayerSize, videoIdOrUrl: string, playerVars: YT.PlayerVars) {
    const createPlayer = () => {
      if (YoutubePlayerService.Player) {
        this.createPlayer(elementId, outputs, size, videoIdOrUrl, playerVars)
      }
    }

    this.api.subscribe(createPlayer)
  }

  private createApi() {
    this.api = new ReplaySubject(1)
    const onYouTubeIframeAPIReady = () => {
      this.api.next(YoutubePlayerService.YT)
    }

    YoutubePlayerService.win['onYouTubeIframeAPIReady'] = onYouTubeIframeAPIReady
  }

  private createPlayer(elementId: string, outputs: PlayerOutputs, size: PlayerSize, videoIdOrUrl: string, playerVars: YT.PlayerVars): YT.Player {
    let videoId = videoIdOrUrl
    if (videoIdOrUrl.startsWith('https://') || videoIdOrUrl.startsWith('http://')) {
      videoId = videoIdOrUrl.split('v=')[1]
    }

    return new YT.Player(elementId, {
      width: size.width || this.defaultSize.width,
      height: size.height || this.defaultSize.height,
      videoId: videoId,
      playerVars: playerVars,
      events: {
        onReady: (ev: YT.PlayerEvent) => {
          this.zone.run(() => outputs.ready && outputs.ready.next(ev.target))
        },
        onStateChange: (ev: YT.PlayerEvent) => {
          this.zone.run(() => outputs.change && outputs.change.next(ev))
        }
      }
    })
  }

  public generateUniqueId() {
    const len = 7
    return Math.random().toString(35).substr(2, len)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/youtube-player/shared/youtube-player.service.ts